import React from 'react';
import { NavLink as Link } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';
import styled from 'styled-components';
import Icon from 'shared/components/Icon';
import { toggleNav } from 'shared/store/modules/nav/actions';
import { css } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsNavOpen } from 'shared/store/modules/nav/selectors';

const NavIcon = styled(Icon)`
  margin-right: 10px;
`;

interface PMNavigationProps {
  navigationIsCollapsed: boolean;
}

const styles = css`
  @media (min-width: 1200px) {
    .collapsed {
      display: none;
    }
  }
`;

export const PMNavigation = ({ navigationIsCollapsed }: PMNavigationProps) => {
  const dispatch = useDispatch();
  const isNavOpen = useSelector(getIsNavOpen);
  const navItems = [
    { path: '/', icon: 'folder', text: 'My Portfolio' },
    { path: '/projects', icon: 'layers', text: 'Projects' },
    { path: '/subscribers', icon: 'people', text: 'Subscribers' }
  ];

  return (
    <Nav className="navigation-primary" vertical css={styles}>
      {navItems.map(item => (
        <NavItem key={item.path} onClick={() => (isNavOpen ? dispatch(toggleNav()) : {})}>
          <NavLink exact={item.path === '/'} tag={Link} to={item.path}>
            <NavIcon icon={item.icon} />
            <span className={`nav-text ${navigationIsCollapsed ? 'collapsed' : ''}`}>{item.text}</span>
          </NavLink>
        </NavItem>
      ))}
    </Nav>
  );
};
